import { render } from "./VisitorCaptureViaMenu.vue?vue&type=template&id=f401d340"
import script from "./VisitorCaptureViaMenu.vue?vue&type=script&lang=js"
export * from "./VisitorCaptureViaMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__